import React from 'react';

export function SkipToMain() {
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[200] focus:px-4 focus:py-2 focus:rounded-xl focus:bg-[var(--color-navy)] focus:text-white focus:shadow-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-teal)]"
      data-testid="skip-to-main"
    >
      Skip to main content
    </a>
  );
}

export default SkipToMain;
